import styled from 'styled-components';

const LogReasonsContainer = styled.div`
  color: var(--grey700);
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  div + p {
    margin: 0;
    margin-left: 20px;
  }
`;
export default LogReasonsContainer;
